import { Button, UserIcon } from "@r360/library";
import React from "react";
import { useDispatch } from "react-redux";
import { getUnpaidReservations } from "../../Helper";
import { useAppSelector } from "../../hooks/useAppSelector";
import useTranslate from "../../hooks/useTranslate";
import { accountSelector, checkoutCartSelector } from "../../selectors/Selectors";
import { setSignUpWrapper } from "../../store/actions/window";
import { confirmationDialog } from "../UI";

type TLoginMyPagesButton = {
    loggedIn: boolean;
    className?: string;
};

export const LoginMyPagesButton = ({ loggedIn, className }: TLoginMyPagesButton) => {
    const t = useTranslate();
    const dispatch = useDispatch();
    const productsNotAddedPath = useAppSelector(checkoutCartSelector).productsNotAddedPath;
    const { reservations } = useAppSelector(accountSelector);
    const hasUnpaidReservations = getUnpaidReservations(reservations).length > 0;

    const handleLoginClick = async () => {
        if (productsNotAddedPath) {
            const response = await confirmationDialog({
                heading: t("book.leave_warning_header"),
                description: t("book.leave_warning_text"),
                confirmBtnText: t("book.leave_warning_confirm"),
                cancelBtnText: t("book.leave_warning_cancel"),
            });

            if (!response) {
                return;
            }
        }

        dispatch(setSignUpWrapper(true, true, false, "/my-pages"));
    };

    return loggedIn ? (
        <Button
            link
            linkTo="/my-pages"
            buttonClassName={className}
            type="my-account"
            exclamationBadge={hasUnpaidReservations}
        >
            {t("book.my_pages")}
        </Button>
    ) : (
        <Button buttonClassName={className} type="login" onClick={handleLoginClick} rightIcon={<UserIcon />}>
            {t("book.menu.login")}
        </Button>
    );
};
